import { isUndefined } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'

export function isOpenFin() {
  return !isUndefined(window.fin)
}

export function getCurrentWindow(): fin.OpenFinWindow {
  if (!window.fin) {
    throw new Error('OpenFin is not available')
  }
  return window.fin.desktop.Window.getCurrent()
}

let currentWindowId = uuidv4()

export function getCurrentWindowId(): string {
  return currentWindowId
}

const ENVIRONMENT_NAME_PROD = 'PROD'

export function getWindowTitle(applicationName: string, environmentName: string): string {
  if (environmentName.toUpperCase() === ENVIRONMENT_NAME_PROD) {
    return applicationName
  } else {
    return `${applicationName} [${environmentName.toUpperCase()}]`
  }
}

// Converts an OpenFin function which takes a success callback and an error callback into a function returning a promise
export function openFinPromisify<TResult>(
  openFinFn: (callback: (result?: TResult) => void, errCallback: (err: string) => void) => void,
  context: any
): () => Promise<TResult>
export function openFinPromisify<T1>(
  openFinFn: (callback: () => void, errCallback: (err: string) => void) => void,
  context: any
): () => Promise<void>
export function openFinPromisify<T1, TResult>(
  openFinFn: (arg1: T1, callback: (result?: TResult) => void, errCallback: (err: string) => void) => void,
  context: any
): (arg1: T1) => Promise<TResult>
export function openFinPromisify<T1, T2, TResult>(
  openFinFn: (arg1: T1, arg2: T2, callback: (result?: TResult) => void, errCallback: (err: string) => void) => void,
  context: any
): (arg1: T1, arg2: T2) => Promise<TResult>
export function openFinPromisify<T1, T2, T3, TResult>(
  openFinFn: (arg1: T1, arg2: T2, arg3: T3, callback: (result?: TResult) => void, errCallback: (err: string) => void) => void,
  context: any
): (arg1: T1, arg2: T2, arg3: T3) => Promise<TResult>
export function openFinPromisify(openFinFn: Function, context: any): Function {
  return function promisified(...args: any[]) {
    return new Promise((resolve, reject) => {
      openFinFn.call(context, ...args, resolve, (errMsg: string) => reject(new Error(errMsg)))
    })
  }
}
